import { Component, Input, OnInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { NavListItem } from '../../models/navListItem';

@Component({
  selector: 'app-nav-list',
  templateUrl: './nav-list.component.html',
  styleUrls: ['./nav-list.component.scss'],
})
export class NavListComponent implements OnInit, OnDestroy, OnChanges {
  constructor(private router: Router) {
    this.routeListener = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.isParentPath = this.list.some(path => path.to === event.url);
      }
    });
  }

  @Input() list: Array<NavListItem>;
  @Input() listClasses: any;
  @Input() expand: boolean = false;

  isParentPath: boolean;
  routeListener: Subscription;
  expandChildren: boolean = false;

  ngOnInit(): void {
    if (this.listClasses['sub-menu']) {
      this.list.forEach(item => (item.subMenu = true));
    }
  }

  ngOnDestroy(): void {
    this.routeListener.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {}

  handleOpen(data: any): void {
    this.isParentPath = this.list.some(path => path.to === data.to);
    this.expandChildren = true;
  }

  trackByFunction(index: number, element: any): any {
    return element.name;
  }
}
